import { setPersonalEmailWarningModal } from '../../store/signUp/slice';
import { EmailSquareIcon } from '../../assets/icons';
import { useDispatch } from '../../store/store';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function PersonalEmailWarning() {
    const dispatch = useDispatch();

    const dismissFunc = () => {
        dispatch(setPersonalEmailWarningModal(false));
    };

    return (
        <Modal
            size='sm'
            closeFunc={dismissFunc}
            icon={<EmailSquareIcon />}
            childClassName={styles.wrapper}
            title='Personal email whitelisting'
            actions='both'
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: dismissFunc,
            }}
            confirmButton={{
                text: 'Continue',
                type: 'Primary',
                onClick: dismissFunc,
            }}
        >
            <span className={styles.text}>
                Registration with personal email addresses is not allowed.
            </span>
            <p className={styles.description}>
                Use the email address associated with your workplace or
                organization to ensure your registration is properly considered.
            </p>
        </Modal>
    )
}
